module.exports = __webpack_public_path__ + "static/img/empty.8e8d6696.png";